import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import {
    Typography,
    Paper,
    IconButton,
    FormHelperText,
    AppBar,
    Tabs,
    Tab,
    Card,
    CardContent,
    Box
} from '@material-ui/core'
import withStyles from '@material-ui/core/styles/withStyles'
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore'
import GetAppIcon from '@material-ui/icons/GetApp'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import firebase from '../firebase'
import { withRouter } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import { saveAs } from '@progress/kendo-file-saver'
import SwipeableViews from 'react-swipeable-views'
import { bindKeyboard } from 'react-swipeable-views-utils'
import { ReactComponent as LoadingClock } from './clock.svg'
import * as Moment from 'moment'
import 'moment/locale/de'
import 'moment/locale/it'
import './styles.css'

function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </Typography>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

const styles = theme => ({
    main: {
        width: 'auto',
        display: 'block',
        margin: theme.spacing(1),
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top center',
        [theme.breakpoints.up(480 + theme.spacing(3) * 2)]: {
            backgroundPosition: 'center center',
        },
    },
    paper: {
        marginTop: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(2)}px`,
        [theme.breakpoints.up(620 + theme.spacing(3) * 2)]: {
            width: 600,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    tabpaper: {
        marginTop: theme.spacing(1),
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        zIndex: 9,
        [theme.breakpoints.up(620 + theme.spacing(3) * 2)]: {
            width: 600,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    cardcontainer: {
        margin: theme.spacing(1),
        padding: 0,
        width: '100%',
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "row",
        alignItems: "baseline",
        justifyContent: "space-around",
        [theme.breakpoints.down(480 + theme.spacing(3) * 2)]: {
            margin: 0,
        },
    },
    card: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: theme.spacing(1),
    },
    submit: {
        padding: 12,
    },
    input: {
        fontSize: 42,
    },
    formHelper: {
        textAlign: 'center',
        marginTop: -5,
    },
})

function Backups(props) {
    const { classes } = props
    const [isadmin, setIsadmin] = useState(false)
    const { t, i18n } = useTranslation()
    const [logged, setLogged] = useState(false)
    const [backuplist, setBackuplist] = useState([])
    const [autobackuplist, setAutobackuplist] = useState([])
    const [isbackup, setIsbackup] = useState(false)
    const [isrestore, setIsrestore] = useState(false)
    const [backupdate, setBackupdate] = useState('')
    const [value, setValue] = useState(0)

    Moment.locale(i18n.language)

    useEffect(() => {
        document.title = window.localStorage.getItem('apptitle') + ` - ${t('dashboard.label')}`
    }, [t])

    useEffect(() => {
        if (firebase.getCurrentUsername()) {
            setLogged(true)
            return
        } else {
            alert(t('loginfirst.label'))
            window.location.href = '/'
            return null
        }
    }, [t])

    useEffect(() => {
        if (firebase.getCurrentUsername()) {
            firebase.checkClaims().then((idTokenResult) => {
                if (!!idTokenResult.claims.admin) {
                    setIsadmin(true)
                } else {
                    return
                }
            })
        }
    }, [])

    useEffect(() => {
        const unsubscribe = firebase.db.collection('backupdate').doc('backup')
            .onSnapshot((snapshot) => {
                if (snapshot.exists) {
                    setBackupdate(snapshot.data().createdAt)
                }
            })
        return () => unsubscribe()
    }, [])

    useEffect(() => {
        const unsubscribe = firebase.db.collection('backupinprogress').doc('25')
            .onSnapshot((snapshot) => {
                if (snapshot.exists) {
                    setIsbackup(true)
                } else {
                    setIsbackup(false)
                    firebase.getBackuplist().then(setBackuplist)
                }
            })
        return () => unsubscribe()
    }, [])

    useEffect(() => {
        const unsubscribe = firebase.db.collection('restoreinprogress').doc('25')
            .onSnapshot((snapshot) => {
                if (snapshot.exists) {
                    setIsrestore(true)
                } else {
                    setIsrestore(false)
                    firebase.getBackuplist().then(setBackuplist)
                }
            })
        return () => unsubscribe()
    }, [])

    useEffect(() => {
        firebase.getBackuplist().then(setBackuplist)
    }, [])

    useEffect(() => {
        firebase.getAutoBackuplist().then(setAutobackuplist)
    }, [])

    const BackupList = useCallback(backuplist
        .sort((a, b) => a.createdAt < b.createdAt ? 1 : -1)
        .map((backup, i) =>
            <Card className={classes.card} style={{ background: localStorage.getItem('projectBox') }} key={i}>
                <CardContent>
                    <Typography variant="body1" gutterBottom>
                        <strong>{Moment(backup.createdAt).format('LLLL')}</strong>
                    </Typography>
                    {isrestore || isbackup ?
                        <LoadingClock style={{ width: 42, marginTop: 15, marginBottom: 15 }} />
                        :
                        <IconButton onClick={() => { restoreBackup(backup.createdAt) }} color="primary" component="span">
                            <SettingsBackupRestoreIcon color='secondary' className={classes.input} />
                        </IconButton>
                    }
                    <FormHelperText className={classes.formHelper}>{t('restore.label')}</FormHelperText>
                    <br /><hr /><br />
                    <span style={{ float: 'left' }}>
                        <IconButton onClick={() => { downloadBackup(backup.createdAt) }} color="primary" component="span">
                            <GetAppIcon color='secondary' className={classes.input} />
                        </IconButton>
                        <FormHelperText className={classes.formHelper}>{t('downloadbackup.label')}</FormHelperText>
                    </span>
                    <span style={{ float: 'right' }}>
                        {isrestore || isbackup ?
                            <span>
                                <LoadingClock style={{ width: 42, marginTop: 15, marginBottom: 15 }} />
                                <FormHelperText className={classes.formHelper}>{t('remove.label')}</FormHelperText>
                            </span>
                            :
                            <span>
                                <IconButton onClick={() => { removeBackup(backup.createdAt) }} color="primary" component="span">
                                    <DeleteForeverIcon color='secondary' className={classes.input} />
                                </IconButton>
                                <FormHelperText className={classes.formHelper}>{t('remove.label')}</FormHelperText>
                            </span>
                        }
                    </span>
                </CardContent>
            </Card>
        )
    )

    const AutoBackupList = useCallback(autobackuplist
        .sort((a, b) => a.createdAt < b.createdAt ? 1 : -1)
        .map((backup, i) =>
            <Card className={classes.card} style={{ background: localStorage.getItem('projectBox') }} key={i}>
                <CardContent>
                    <Typography variant="body1" gutterBottom>
                        {t('autobackupof.label')}<br />
                        <strong>{Moment(backup.createdAt).format('LLLL')}</strong>
                    </Typography>
                    {isrestore || isbackup ?
                        <LoadingClock style={{ width: 42, marginTop: 15, marginBottom: 15 }} />
                        :
                        <IconButton onClick={() => { restoreAutoBackup(backup.createdAt) }} color="primary" component="span">
                            <SettingsBackupRestoreIcon color='secondary' className={classes.input} />
                        </IconButton>
                    }
                    <FormHelperText className={classes.formHelper}>{t('restore.label')}</FormHelperText>
                    <br /><hr /><br />
                    <span style={{ float: 'left' }}>
                        <IconButton onClick={() => { downloadAutoBackup(backup.createdAt) }} color="primary" component="span">
                            <GetAppIcon color='secondary' className={classes.input} />
                        </IconButton>
                        <FormHelperText className={classes.formHelper}>{t('downloadbackup.label')}</FormHelperText>
                    </span>
                    <span style={{ float: 'right' }}>
                        {isrestore || isbackup ?
                            <span>
                                <LoadingClock style={{ width: 42, marginTop: 15, marginBottom: 15 }} />
                                <FormHelperText className={classes.formHelper}>{t('remove.label')}</FormHelperText>
                            </span>
                            :
                            <span>
                                <IconButton onClick={() => { removeAutoBackup(backup.createdAt) }} color="primary" component="span">
                                    <DeleteForeverIcon color='secondary' className={classes.input} />
                                </IconButton>
                                <FormHelperText className={classes.formHelper}>{t('remove.label')}</FormHelperText>
                            </span>
                        }
                    </span>
                </CardContent>
            </Card>
        )
    )

    const handleChange = (event, newValue) => {
        setValue(newValue);
    }

    const handleChangeIndex = index => {
        setValue(index)
    }

    console.log = console.warn = () => { }
    const BindKeyboardSwipeableViews = bindKeyboard(SwipeableViews)

    return (
        <main className={classes.main}>
            <div className={classes.content}>
                {logged ?
                    <span>
                        {isadmin ?
                            <span>
                                <Paper className={classes.tabpaper} style={{ alignItems: 'center', textAlign: 'center', }}>
                                    <AppBar position="static" style={{ borderTopLeftRadius: 4, borderTopRightRadius: 4, zIndex: 9 }}>
                                        <Tabs
                                            value={value}
                                            onChange={handleChange}
                                            indicatorColor="secondary"
                                            textColor="inherit"
                                            variant="fullWidth"
                                            scrollButtons="auto"
                                            aria-label="Projects Tabs">
                                            <Tab className={classes.tabtext} label='Backups' {...a11yProps(0)} />
                                            <Tab className={classes.tabtext} label='Auto Backups' {...a11yProps(1)} />
                                        </Tabs>
                                    </AppBar>
                                    <BindKeyboardSwipeableViews
                                        index={value}
                                        onChangeIndex={handleChangeIndex}
                                        style={{ minWidth: '100%' }}
                                    >
                                        <TabPanel value={value} index={0}>
                                            <Box className={classes.cardcontainer}>
                                                {BackupList.length !== 0 ?
                                                    <span>{BackupList}</span>
                                                    :
                                                    <span>{t('nobackup.label')}</span>
                                                }
                                            </Box>
                                        </TabPanel>
                                        <TabPanel value={value} index={1}>
                                            <Box className={classes.cardcontainer}>
                                                {AutoBackupList.length !== 0 ?
                                                    <span>{AutoBackupList}</span>
                                                    :
                                                    <span>{t('nobackup.label')}</span>
                                                }
                                            </Box>
                                        </TabPanel>
                                    </BindKeyboardSwipeableViews>
                                </Paper>
                            </span>
                            :
                            <Paper className={classes.paper} style={{ textAlign: 'center', }}>
                                <Typography variant="button" display="block" gutterBottom>
                                    <strong>{t('noprivileges.label')}</strong>
                                </Typography>
                            </Paper>
                        }
                    </span>
                    :
                    <span></span>
                }
            </div>
        </main>
    )

    function restoreBackup(i) {
        setIsrestore(true)
        toast.success(`${t('firestoreisrestored.label')}`)
        firebase.storage.ref('backup').child(`${i}`).getDownloadURL()
            .then(url => {
                firebase.restoreHistory(url, `${i}`, backupdate)
            }).catch((error) => {
                console.log(error)
            })
    }

    function restoreAutoBackup(i) {
        setIsrestore(true)
        toast.success(`${t('firestoreisrestored.label')}`)
        firebase.storage.ref('autobackup').child(`${i}`).getDownloadURL()
            .then(url => {
                firebase.restoreAutoHistory(url, `${i}`, backupdate)
            }).catch((error) => {
                console.log(error)
            })
    }

    function removeBackup(i) {
        toast.success(`${t('backupremoved.label')}`)
        firebase.db.doc(`backuplist/${i}`).delete()
            .then(() => {
                firebase.getBackuplist().then(setBackuplist)
            }).then(() => {
                firebase.storage.ref(`backup/${i}`).getDownloadURL()
                    .then(url => {
                        var storage = firebase.storage
                        var storageRef = storage.ref()
                        var avatarUrl = storage.refFromURL(url)
                        avatarUrl.getMetadata().then((metadata) => {
                            var avatarName = storageRef.child(`backup/${metadata.name}`)
                            avatarName.delete()
                        }).catch(() => {
                            return
                        })
                    })
            }).catch((error) => {
                toast.error(error)
                return
            })
    }

    function removeAutoBackup(i) {
        toast.success(`${t('backupremoved.label')}`)
        firebase.db.doc(`autobackuplist/${i}`).delete()
            .then(() => {
                firebase.getAutoBackuplist().then(setAutobackuplist)
            }).then(() => {
                firebase.storage.ref(`autobackup/${i}`).getDownloadURL()
                    .then(url => {
                        var storage = firebase.storage
                        var storageRef = storage.ref()
                        var avatarUrl = storage.refFromURL(url)
                        avatarUrl.getMetadata().then((metadata) => {
                            var avatarName = storageRef.child(`autobackup/${metadata.name}`)
                            avatarName.delete()
                        }).catch(() => {
                            return
                        })
                    })
            }).catch((error) => {
                toast.error(error)
                return
            })
    }

    async function downloadBackup(i) {
        var backupJson = await firebase.storage.ref('backup').child(i.toString()).getDownloadURL()
        console.log(backupJson)
        var dateNow = parseInt(i)
        var oReq = new XMLHttpRequest()
        var URLToJSON = 'https://cors-anywhere.herokuapp.com/' + backupJson
        oReq.open('GET', URLToJSON, true)
        oReq.responseType = 'blob'
        oReq.onload = () => {
            var file = new Blob([oReq.response], {
                tyle: 'application/json'
            })
            saveAs(file, 'backup' + Moment(dateNow).format() + '.json')
        }
        oReq.send()
    }

    async function downloadAutoBackup(i) {
        var backupJson = await firebase.storage.ref('autobackup').child(i.toString()).getDownloadURL()
        console.log(backupJson)
        var dateNow = parseInt(i)
        var oReq = new XMLHttpRequest()
        var URLToJSON = 'https://cors-anywhere.herokuapp.com/' + backupJson
        oReq.open('GET', URLToJSON, true)
        oReq.responseType = 'blob'
        oReq.onload = () => {
            var file = new Blob([oReq.response], {
                tyle: 'application/json'
            })
            saveAs(file, 'autobackup' + Moment(dateNow).format() + '.json')
        }
        oReq.send()
    }

}

export default withRouter(withStyles(styles)(Backups))